// extracted by mini-css-extract-plugin
export default {"button":"AddButton_button__u5+Z-","text":"AddButton_text__0X-1O"};